import { LightboxViewerWithTranslations } from '../components/LightboxViewer';

declare let ModuleRegistry: any;

ModuleRegistry.registerComponent(
  'LightboxViewer.main',
  () => LightboxViewerWithTranslations,
);
